<template>
    <div>
        <breadCrumb 
            :icon="'fa-info-circle'"
            :category="$t(`sideNav.navSalonSetting`)"
            :subCategory="$t(`subMenu.salon_setting_info`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 pb-4">
                    <div class="row w-100">
                        <div class="col-sm-12 col-md-4"> 
                            <div class="form-group d-flex">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect  v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                        <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                       <ul class="nav nav-tabs mb-5" role="tablist">
                            <li class="nav-item" v-for="infoTab in $i18n.messages[$i18n.locale].tab.infoTabs" :key="infoTab.id">
                                <a :class="{'active': selectedTab == infoTab.id}" class="nav-link" role="tab" @click="selectedTab = infoTab.id">{{infoTab.text}}</a>
                            </li>
                        </ul> 
                        <div v-if="Object.keys(results).length != 0" class="tab-content mt-5">
                            <general :class="{'active': selectedTab == 'general'}" class="tab-pane" :results="results" @submitInfo="submitInfo"></general>
                            <slide :class="{'active': selectedTab == 'slide'}" class="tab-pane" :slider="results.slider" @submitSlider="submitInfo"></slide>
                            <gallery :class="{'active': selectedTab == 'gallery'}" class="tab-pane" :gallery="results.gallery" @submitGallery="submitInfo"></gallery>
                            <testimonial :class="{'active': selectedTab == 'testimonial'}" class="tab-pane" :testimonial="results.testimonial" @submitInfo="submitInfo"></testimonial>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'

import General from './Info_General'
import Slide from './Info_Slide'
import Gallery from './Info_Gallery'
import Testimonial from './Info_Testimonial'

export default {
    name: 'info',
    components:{
        General, Slide, Gallery, Testimonial, BreadCrumb
    },
    data(){
        return{
            outlet: [], selectedOutlet: {}, selectedTab: "",
            results: [], generalKey: 0,
        }
    }, 
    methods:{
        closeModal(isError){
            if(!isError){
                this.selectedTab = 'general'
                this.getInfo();
            }
            this.$parent.isModalShow = false;
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.getInfo();
        },       
        submitInfo(item){
            var data = Object.assign(this.results, item);
   
            const url = this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.INFO
            let $vm = this
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.salon_setting_info') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();
                }
            })
        },
        getInfo(){
            let $vm = this;
            $vm.results = [];
            const url = $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.INFO

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.results = response.data;  
                $vm.selectedTab = "general"
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            }) 
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.getInfo();  
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
.show{
    display: block;
}
</style>